import React from 'react';
import Hdr from '../shared/Hdr';

import { useState, useEffect } from 'react';
import swal from 'sweetalert';

import { apiPath1 } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';

function ToolHistory() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const usrName = localStorage.getItem('userName');

  const [categoryData, setCategoryData] = useState([])
  const [tools, setTools] = useState([])
  const [categoryId, setCategoryId] = useState()
  const [historyStatus, setHistoryStatus] = useState([])
  const [history, setHistory] = useState([])
  const [toolCode, setToolCode] = useState()
  const [toolName, setToolName] = useState()
  const [toolId,setToolId] = useState()
  const [toolDescription,setToolDescription] = useState()
  const [toolTag,setToolTag] = useState()

  const [selectCategoryValue, setSelectCategoryValue] = useState('0')

  useEffect(() => {
    getToolCategory()
  }, [])

  /* LIST OF ALL TOOL CATAGORY List */

  async function getToolCategory() {

    let result = await fetch(apiPath1 + "HeavyToolsCategory",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setCategoryData(result.data) }
    else { setCategoryData([]) }
  }

  /* LIST OF ALL TOOLS CATAGORYWISE */
  async function getTools(id) {

//     alert(id)

    let result = await fetch(apiPath1 + "ToolCategoryWise/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setTools(result.data) }
    else { setTools([]) }
  }

  async function getHistory() {

 //    alert(toolId)

    let result = await fetch(apiPath1 + "HeavyToolMovementHistory/" + toolId,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    setHistoryStatus(result.status)

    if (result.status === true) {
      setHistory(result.data)
      setToolDescription(result.data[0].ToolDescription)
      setToolTag(result.data[0].ToolTag)
    }

    else { setHistory([]) }
  }



  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  function categoryHandler(e) {

    if (e.target.value === '0') {
      setTools([])
      setHistoryStatus(false)
      setHistory([])
    }

    e.preventDefault()
    setSelectCategoryValue(e.target.value)
    setCategoryId(e.target.value)
    getTools(e.target.value)
  }

  function toolHandler(e) {
//    alert(e.target.value)
  //  setToolCode(e.target.value)
    setToolId(e.target.value)
  }

  function typeToName(type) {

    switch (type) {
      case 'I':
        return ('Issued')
      case "D":
        return ("Indented")
      case "R":
        return ("Received")
      case 'T':
        return ("Transferred")
      case 'N':
        return ("Returned")
      case 'P':
        return ("Purchased")
      case 'X':
        return ("Send for Repair")
      case 'O':
        return ("Opening Entry")
      case 'Y':
        return ("Repaired & Returned")
      default:
        return (type)
    }

    return (type)
  }


  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Movement History of Heavy Tool'} />

      <div className="row p16" style={{ 'height': '100%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* SEARCH OPTION SECTION */}
          <div className="row mb16 pl64 pb16" style={{ 'border-bottom': '1px solid #B9B9B9' }}>

            <div className="c12-l-3">
              <p className='txt-darkblue' >Select Tool Category</p>
              <select className="small" value={selectCategoryValue} onChange={categoryHandler} style={{ "width": '98%' }} >
                <option value="0" >Open List</option>
                {
                  categoryData.map((item, index) =>
                    <option key={item.id} value={item.id}>{item.category_name}</option>
                  )
                }
              </select>
            </div>
            <div className="c12-l-3">
              <p className='txt-darkblue' >Select A Heavy Tool</p>
              <select className="small" onChange={toolHandler} style={{ "width": '98%' }} >
                <option value="0" >Open List</option>
                {
                  tools.map((item, index) =>
                    <option key={item.id} value={item.id}>{item.tool_description}</option>
                  )
                }
              </select>
            </div>
            <div className="c12-l-3 align-bottom-right">
              <button onClick={getHistory} type="button" name="button"
                className="btn gradient round xl">Show Movement History</button>
            </div>
          </div>

          {/* HEADING SECTION */}
          <div className="">
            {
              (historyStatus === true ? <h5 className=' center wide'>Movement History of Tool : {toolTag} - {toolDescription}</h5> : <h5 className=' center wide'>Movement History of Tool</h5>)
            }
          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4 mt8" style={{ 'height': '75%' }}>
            <table className='table-border-grey mx-auto'>
              <thead className='thead-blue'>
                <th className="th-border left color-reverse" width="15%">Transaction Date</th>
                <th className="th-border left color-reverse" width="25%">Reference Document</th>
                <th className="th-border left color-reverse" width="25%">Transaction Type</th>
                <th className="th-border left color-reverse" width="20%">Status</th>
                <th className="th-border left color-reverse" width="25%">StoreName</th>
              </thead>
              <tbody >
                {
                  (historyStatus === true ?
                    (
                      history.map((item, index) =>
                        <tr className="tr-two-color-grey" key={index}>

                          <td className="">{item.Trdate}</td>
                          <td className="">{item.RefDoc}</td>
                          <td className="">{typeToName(item.TrType)}</td>
                          <td className="">{item.TrStatus}</td>
                          <td className="">{item.StoreName}</td>

                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>





        </div>
      </div>


    </div>
  );
}

export default ToolHistory;